import angular from "angular"

const service = [
  "$rootScope",
  "$location",
  "$state",
  "$transitions",
  function($rootScope, $location, $state, $transitions) {
    var self = this

    self.routes = {
      //corregir para que contenga una expresión con el id del alumno
      "ficha-alumno": "estudiantes/",
      "lista-alumnos": "estudiantes/"
    }

    self.getActiveRoute = function() {
      var activeRoute = $location.path()

      switch (activeRoute) {
        case "/estudiantes/":
          return "lista-alumnos"
        case "/home":
          return "home"
        case "/student":
          return "student-profile"
        case "/usuario/":
          return "usuario"
        case "/atenciones/":
          return "atenciones"
        case "/admin/":
          return "admin"
        case "/ayuda/":
          return "ayuda"
        case "/reportes/":
          return "reportes"
        default:
          return "ficha-alumno"
      }
    }

    $transitions.onSuccess({}, transition => {
      console.log(
        "Successful Transition from " + transition.from().name + " to " + transition.to().name
      )
      this.changeActiveRoute()
    })

    this.routeActive = this.getActiveRoute()

    this.changeActiveRoute = () => {
      self.routeActive = self.getActiveRoute()
      $rootScope.$broadcast("route-changed", self.routeActive)
    }

    /* Helpers para ir a rutas específicas */
    self.irAFichaAlumno = function(alumnoId) {
      $location.path(self.routes["ficha-alumno"] + alumnoId)
    }

    self.irAListaAlumnos = function() {
      $location.path(self.routes["lista-alumnos"])
    }

    self.irAUsuario = function() {
      $state.go("app.usuario")
    }

    self.irAAtenciones = function() {
      $state.go("app.atenciones")
    }

    self.irAAdmin = function() {
      $state.go("app.admin")
    }

    self.irAAyuda = function() {
      $state.go("app.ayuda")
    }

    self.irAReportes = function() {
      $state.go("app.reportes")
    }

    self.irAHome = function() {
      $state.go("app.home")
    }

    self.reloadView = function() {
      $state.reload()
    }

    return {
      irAFichaAlumno: self.irAFichaAlumno,
      irAListaAlumnos: self.irAListaAlumnos,
      irAUsuario: self.irAUsuario,
      irAAtenciones: self.irAAtenciones,
      irAAdmin: self.irAAdmin,
      irAAyuda: self.irAAyuda,
      irAReportes: self.irAReportes,
      irAHome: self.irAHome,
      routeActive: self.routeActive,
      getActiveRoute: self.getActiveRoute,
      reloadView: self.reloadView
    }
  }
]

angular.module("appModule").service("appRoutesService", service)
